import Axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { TSourceResponse } from 'types/GlobalSource'

const homepal_mdm_api =
  process.env.REACT_APP_HOMEPAL_MDM_API_DEV || 'http://localhost:3990/'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? homepal_mdm_api
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/connections/active-sources`

export type TActiveSourceBody = {
  data: {
    attributes: Record<string, unknown>
  }
}

export type TCreateActiveSourceResponse = TSourceResponse & {
  meta: {
    active_source_id: string
  }
}

export type TResetPasswordBody = {
  data: {
    id: string
  }
}

export async function create(body: TActiveSourceBody) {
  return Axios.post<TCreateActiveSourceResponse>(
    URL,
    body,
    parseAuthenticationHeader()
  )
}

export async function update(id: string, body: TActiveSourceBody) {
  const url = `${URL}/${id}`

  return Axios.patch<TSourceResponse>(url, body, parseAuthenticationHeader())
}

export async function remove(id: string) {
  const url = `${URL}/${id}`

  return Axios.delete(url, parseAuthenticationHeader())
}

export async function upload(id: string, body: FormData) {
  const url = `${URL}/${id}/upload`

  return Axios.post<TSourceResponse>(url, body, parseAuthenticationHeader())
}

export async function resetPassword(id: string, body: TResetPasswordBody) {
  const url = `${URL}/${id}/reset-password`

  return Axios.patch<TSourceResponse>(url, body, parseAuthenticationHeader())
}

export async function activate(id: string) {
  const url = `${URL}/${id}/activate`

  return Axios.post(url, {}, parseAuthenticationHeader())
}

export async function createSFTPSettings(id: string) {
  const url = `${URL}/${id}/create-sftp-settings`

  return Axios.post<TSourceResponse>(url, {}, parseAuthenticationHeader())
}

export async function scan(id: string, file?: File) {
  const url = `${URL}/${id}/scan`

  if (file) {
    const body = new FormData()

    body.append('file', file)

    return Axios.post(url, body, parseAuthenticationHeader())
  }

  return Axios.post(url, {}, parseAuthenticationHeader())
}
